<template>
    <div>
        <qrcode :value="otpauth" :options="{ width, margin }"></qrcode>
    </div>
</template>

<script>
import Vue from 'vue';
import VueQrcode from '@chenfengyuan/vue-qrcode';

Vue.component(VueQrcode.name, VueQrcode);

export default {
    props: {
        secret: {
            type: String,
            required: true
        },
        user: {
            type: String,
            required: true
        },
        width: {
            type: Number,
            default: 200
        },
        margin: {
            type: Number,
            default: 0
        }
    },
    computed: {
        /**
         * Generate the issuer location.
         *
         * @return {string}
         */
        issuer() {
            return window.document.location.hostname;
        },
        /**
         * Generate the otpath url for the authenticator qr image.
         *
         * @return {string}
         */
        otpauth() {
            if (!this.secret) {
                return;
            }

            let query = new URLSearchParams();

            query.append('secret', this.secret);
            query.append('issuer', this.issuer);

            return 'otpauth://totp/' + this.issuer + ':' + this.user + '?' + query.toString();
        }
    }
};
</script>
